import {ControlItem} from "./controlItem";

export class DictionaryItem {
  itemId? : number;
  name?: string;
  parentId? : number;
  dictionary?: string;
  details?: string;
  vendor?: DictionaryItem;
  details2?: string;
  dictionaryControlItems?: any[];
  securityTopic?: string;
  supportingFeatures?: string;
  fulfillmentMethod?: string;
  inheritance?: string;
  guidance?: string;
  url?: string;
  lastUpdated?: string;
  customerResponsibilities?: string;
  configInfo? :string;
  logoFileName?: string;
  topic?: string;
  elixir?: string;
  isFirstTopic?: boolean;
  topicStart?: number;
  price?: string;
  contact?: string;
  configDetails?: string;
  businessUnits?: string[];
  scoring?: string[];

}
